import React, { useEffect, useState } from "react";
import axios from "axios";

import Layout from "../../layouts";
import Header from "../../layouts/header";
import Footer from "../../layouts/footer";
import ScrollToTop from "../../components/scroll-to-top";
import SEO from "../../components/seo";

import { showToast } from "../../utils/toast.js";

const API = process.env.REACT_APP_API_URL;
const token = sessionStorage.getItem("token");

const ConsolidadoContainer = () => {
    const [consolidado, setConsolidado] = useState([]);
    const [loading, setLoading] = useState(false);
    const [busqueda, setBusqueda] = useState("");
    const [filtroEstado, setFiltroEstado] = useState("todos");
    const [filtroGenero, setFiltroGenero] = useState("todos");

    const empleadosFiltrados = consolidado.filter(emp => {

        const texto = busqueda.toLowerCase();

        const coincideNombre =
            `${emp.nombre} ${emp.apellido}`
                .toLowerCase()
                .includes(texto);

        const coincideEstado =
            filtroEstado === "todos" ||
            emp.estatus_laboral === filtroEstado;

        const coincideGenero =
            filtroGenero === "todos" ||
            emp.genero === filtroGenero;

        return (
            coincideNombre &&
            coincideEstado &&
            coincideGenero
        );
    });

    const fetchConsolidado = async () => {
        try {
            setLoading(true);

            const r = await axios.get(
                `${API}/consolidado-personal/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            const data = Array.isArray(r.data)
                ? r.data
                : Array.isArray(r.data?.results)
                    ? r.data.results
                    : [];

            setConsolidado(data);

        } catch (error) {
            console.error("Error al cargar consolidado:", error);
            showToast("Error al cargar consolidado", "error");
            setConsolidado([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchConsolidado();
    }, []);

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";

        const d = new Date(dateStr);

        return `${String(d.getDate()).padStart(2, "0")}-${String(
            d.getMonth() + 1
        ).padStart(2, "0")}-${d.getFullYear()}`;
    };

    const thStyle = {
        borderBottom: "2px solid #eee",
        padding: "12px",
        textAlign: "left",
        whiteSpace: "nowrap",
        background: "#f8f9fa"
    };

    const tdStyle = {
        padding: "12px",
        borderBottom: "1px solid #f0f0f0",
        whiteSpace: "nowrap"
    };

    const totalEmpleados = consolidado.length;

    const activos = consolidado.filter(
        e => e.estatus_laboral === "Activo"
    ).length;

    const renuncias = consolidado.filter(
        e => e.estatus_laboral === "Renuncia"
    ).length;

    const despidos = consolidado.filter(
        e =>
            e.estatus_laboral === "Despido" ||
            e.estatus_laboral === "Despido Justificado"
    ).length;

    const despidosJustificados = consolidado.filter(
        e => e.estatus_laboral === "Despido Justificado"
    ).length;

    const retirados = consolidado.filter(
        e => e.estatus_laboral === "Retirado"
    ).length;


    return (
        <Layout>
            <SEO title="Consolidado de Personal" />

            <div
                style={{
                    display: "flex",
                    gap: "12px",
                    flexWrap: "wrap",
                    marginBottom: "20px"
                }}
            >
                <input
                    type="text"
                    placeholder="Buscar trabajador..."
                    value={busqueda}
                    onChange={(e) => setBusqueda(e.target.value)}
                    style={{
                        flex: 1,
                        minWidth: "250px",
                        padding: "10px",
                        borderRadius: "8px",
                        border: "1px solid #ccc"
                    }}
                />

                <select
                    value={filtroEstado}
                    onChange={(e) => setFiltroEstado(e.target.value)}
                    style={{
                        padding: "10px",
                        borderRadius: "8px"
                    }}
                >
                    <option value="todos">Todos</option>
                    <option value="Activo">Activos</option>
                    <option value="Retirado">Retirados</option>
                </select>

                <select
                    value={filtroGenero}
                    onChange={(e) => setFiltroGenero(e.target.value)}
                    style={{
                        padding: "10px",
                        borderRadius: "8px"
                    }}
                >
                    <option value="todos">Todos</option>
                    <option value="Masculino">Masculino</option>
                    <option value="Femenino">Femenino</option>
                </select>
            </div>

            <div style={{ display: "flex", minHeight: "100vh" }}>
                <div
                    style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    <Header />

                    <main
                        className="main-content site-wrapper-reveal"
                        style={{
                            flex: 1,
                            backgroundColor: "#EEF2F7",
                            padding: "48px 20px 8rem"
                        }}
                    >
                        <div
                            style={{
                                width: "min(1600px, 98vw)",
                                margin: "0 auto"
                            }}
                        >
                            <h2
                                style={{
                                    textAlign: "center",
                                    marginBottom: "25px",
                                    color: "#023047"
                                }}
                            >
                                Consolidado de Personal
                            </h2>

                            {/* RESUMEN */}
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns:
                                        "repeat(auto-fit, minmax(220px, 1fr))",
                                    gap: "15px",
                                    marginBottom: "25px"
                                }}
                            >
                                <div
                                    style={{
                                        background: "#fff",
                                        borderRadius: "12px",
                                        padding: "20px",
                                        boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
                                    }}
                                >
                                    <div
                                        style={{
                                            color: "#666",
                                            fontSize: "14px"
                                        }}
                                    >
                                        Total Personal
                                    </div>

                                    <div
                                        style={{
                                            fontSize: "28px",
                                            fontWeight: "bold",
                                            color: "#023047"
                                        }}
                                    >
                                        {totalEmpleados}
                                    </div>
                                </div>

                                <div
                                    style={{
                                        background: "#fff",
                                        borderRadius: "12px",
                                        padding: "20px",
                                        boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
                                    }}
                                >
                                    <div
                                        style={{
                                            color: "#666",
                                            fontSize: "14px"
                                        }}
                                    >
                                        Activos
                                    </div>

                                    <div
                                        style={{
                                            fontSize: "28px",
                                            fontWeight: "bold",
                                            color: "#28a745"
                                        }}
                                    >
                                        {activos}
                                    </div>
                                </div>

                                <div
                                    style={{
                                        background: "#fff",
                                        borderRadius: "12px",
                                        padding: "20px",
                                        boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
                                    }}
                                >
                                    <div
                                        style={{
                                            color: "#666",
                                            fontSize: "14px"
                                        }}
                                    >
                                        Renuncias
                                    </div>

                                    <div
                                        style={{
                                            fontSize: "28px",
                                            fontWeight: "bold",
                                            color: "#f59e0b"
                                        }}
                                    >
                                        {renuncias}
                                    </div>
                                </div>

                                <div
                                    style={{
                                        background: "#fff",
                                        borderRadius: "12px",
                                        padding: "20px",
                                        boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
                                    }}
                                >
                                    <div
                                        style={{
                                            color: "#666",
                                            fontSize: "14px"
                                        }}
                                    >
                                        Despidos
                                    </div>

                                    <div
                                        style={{
                                            fontSize: "28px",
                                            fontWeight: "bold",
                                            color: "#dc3545"
                                        }}
                                    >
                                        {despidos}
                                    </div>
                                </div>

                                <div
                                    style={{
                                        background: "#fff",
                                        borderRadius: "12px",
                                        padding: "20px",
                                        boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
                                    }}
                                >
                                    <div
                                        style={{
                                            color: "#666",
                                            fontSize: "14px"
                                        }}
                                    >
                                        Despidos Justificados
                                    </div>

                                    <div
                                        style={{
                                            fontSize: "28px",
                                            fontWeight: "bold",
                                            color: "#9b2226"
                                        }}
                                    >
                                        {despidosJustificados}
                                    </div>
                                </div>
                            </div>

                            {/* FILTROS */}
                            <div
                                style={{
                                    background: "#fff",
                                    borderRadius: "12px",
                                    padding: "20px",
                                    marginBottom: "20px",
                                    boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "12px",
                                        flexWrap: "wrap"
                                    }}
                                >
                                    <input
                                        type="text"
                                        placeholder="Buscar trabajador..."
                                        value={busqueda}
                                        onChange={(e) =>
                                            setBusqueda(e.target.value)
                                        }
                                        style={{
                                            flex: 1,
                                            minWidth: "250px",
                                            padding: "10px",
                                            borderRadius: "8px",
                                            border: "1px solid #ccc"
                                        }}
                                    />

                                    <select
                                        value={filtroEstado}
                                        onChange={(e) =>
                                            setFiltroEstado(e.target.value)
                                        }
                                        style={{
                                            padding: "10px",
                                            borderRadius: "8px",
                                            border: "1px solid #ccc"
                                        }}
                                    >
                                        <option value="todos">Todos los estados</option>
                                        <option value="Activo">Activos</option>
                                        <option value="Renuncia">Renuncias</option>
                                        <option value="Despido">Despidos</option>
                                        <option value="Retirado">Retirados</option>
                                        <option value="Despido Justificado">Despido Justificado</option>
                                    </select>

                                    <select
                                        value={filtroGenero}
                                        onChange={(e) =>
                                            setFiltroGenero(e.target.value)
                                        }
                                        style={{
                                            padding: "10px",
                                            borderRadius: "8px",
                                            border: "1px solid #ccc"
                                        }}
                                    >
                                        <option value="todos">
                                            Todos los géneros
                                        </option>
                                        <option value="Masculino">
                                            Masculino
                                        </option>
                                        <option value="Femenino">
                                            Femenino
                                        </option>
                                    </select>
                                </div>
                            </div>

                            {/* TABLA */}
                            <div
                                style={{
                                    background: "#fff",
                                    borderRadius: "12px",
                                    padding: "20px",
                                    boxShadow:
                                        "0 4px 20px rgba(0,0,0,0.08)"
                                }}
                            >
                                <div style={{ overflowX: "auto" }}>
                                    <table
                                        style={{
                                            width: "100%",
                                            borderCollapse: "collapse"
                                        }}
                                    >
                                        <thead>
                                            <tr>
                                                <th style={thStyle}>
                                                    Nombre Completo
                                                </th>
                                                <th style={thStyle}>Género</th>
                                                <th style={thStyle}>Edad</th>
                                                <th style={thStyle}>
                                                    Formación
                                                </th>
                                                <th style={thStyle}>Puesto</th>

                                                <th style={thStyle}>
                                                    Inicio Laboral
                                                </th>

                                                <th style={thStyle}>
                                                    Fin Laboral
                                                </th>

                                                <th style={thStyle}>
                                                    Antigüedad
                                                </th>

                                                <th style={thStyle}>
                                                    Estado
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td
                                                        colSpan="9"
                                                        style={{
                                                            textAlign: "center",
                                                            padding: "30px"
                                                        }}
                                                    >
                                                        Cargando...
                                                    </td>
                                                </tr>
                                            ) : empleadosFiltrados.length > 0 ? (
                                                empleadosFiltrados.map(
                                                    (empleado) => (
                                                        <tr
                                                            key={
                                                                empleado.idempleado
                                                            }
                                                        >
                                                            <td style={tdStyle}>
                                                                <strong>
                                                                    {
                                                                        empleado.nombre
                                                                    }{" "}
                                                                    {
                                                                        empleado.apellido
                                                                    }
                                                                </strong>
                                                            </td>

                                                            <td style={tdStyle}>
                                                                {
                                                                    empleado.genero
                                                                }
                                                            </td>

                                                            <td style={tdStyle}>
                                                                {
                                                                    empleado.edad
                                                                }
                                                            </td>

                                                            <td
                                                                style={{
                                                                    ...tdStyle,
                                                                    maxWidth:
                                                                        "350px",
                                                                    whiteSpace:
                                                                        "normal"
                                                                }}
                                                            >
                                                                {
                                                                    empleado.formacion_profesional
                                                                }
                                                            </td>

                                                            <td style={tdStyle}>
                                                                {empleado.puesto}
                                                            </td>

                                                            <td style={tdStyle}>
                                                                {formatDate(
                                                                    empleado.inicio_relacion_laboral
                                                                )}
                                                            </td>

                                                            <td style={tdStyle}>
                                                                {formatDate(
                                                                    empleado.fin_relacion_laboral
                                                                )}
                                                            </td>

                                                            <td style={tdStyle}>
                                                                {empleado.anios_trabajo ?? 0} años
                                                            </td>

                                                            <td style={tdStyle}>
                                                                <span
                                                                    style={{
                                                                        background:
                                                                            empleado.estatus_laboral ===
                                                                                "Activo"
                                                                                ? "#d4edda"
                                                                                : "#f8d7da",
                                                                        color:
                                                                            empleado.estatus_laboral ===
                                                                                "Activo"
                                                                                ? "#155724"
                                                                                : "#721c24",
                                                                        padding:
                                                                            "5px 12px",
                                                                        borderRadius:
                                                                            "20px",
                                                                        fontWeight:
                                                                            "600",
                                                                        fontSize:
                                                                            "12px"
                                                                    }}
                                                                >
                                                                    {
                                                                        empleado.estatus_laboral
                                                                    }
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )
                                                )
                                            ) : (
                                                <tr>
                                                    <td
                                                        colSpan="9"
                                                        style={{
                                                            textAlign: "center",
                                                            padding: "30px"
                                                        }}
                                                    >
                                                        No se encontraron registros
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </main>

                    <Footer />
                </div>

                <ScrollToTop />
            </div>
        </Layout>
    );
};

export default ConsolidadoContainer;